import { multiUserApi } from "../../shared/utils/multiUserFunctions";

export const getAccessToken = () => {
  return (
    multiUserApi.getUserKey("replacement_token") ||
    multiUserApi.getUserKey("access_token")
  );
};
